import { Controller } from "@hotwired/stimulus"

const FEEDBACK_DURATION = 2000

// Inside Front, the clipboard write is refused until clipboard access is
// enabled in the plugin's Front settings.
export default class extends Controller {
  static values = { text: String, copiedLabel: String, failedLabel: String }

  connect() {
    this.label = this.element.textContent
  }

  disconnect() {
    clearTimeout(this.restoreLabelTimeout)
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.showFeedback(this.copiedLabelValue)
    } catch {
      this.showFeedback(this.failedLabelValue)
    }
  }

  showFeedback(feedback) {
    this.element.textContent = feedback
    clearTimeout(this.restoreLabelTimeout)
    this.restoreLabelTimeout = setTimeout(() => { this.element.textContent = this.label }, FEEDBACK_DURATION)
  }
}
